export const HEADER_WRAPPER_ID = 'headerWrapper';
export const STICKY_HEADER_CONTENT_ID = 'stickyContent';
